import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {isAxiosError} from "axios";
import {SirenDefaultBroadcastConfig} from "./useGetSirenDefaultBroadcastConfigs";
import {useEvents} from "../../../lib/useEvents";

export type SirenDefaultBroadcastConfigInput = {
    clientID?: string;
    departmentID?: string;
    broadcastDuration: number;
    broadcastDurationDisplayFormat: string;
    cycleCount: number;
    cycleInterval: number;
    cycleIntervalDisplayFormat: string;
    deliveryMethodInterval: number;
    deliveryMethodIntervalDisplayFormat: string;
};

export function useUpsertSirenDefaultBroadcastConfig() {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {emit} = useEvents();

    const save = useCallback(async (input: SirenDefaultBroadcastConfigInput): Promise<SirenDefaultBroadcastConfig> => {
        setSaving(true);
        setError(null);
        try {
            const res = await platformAPI.post<SirenDefaultBroadcastConfig>("api/siren/default-broadcast-config", input);
            emit("siren:broadcastConfig:changed", {clientID: input.clientID, departmentID: input.departmentID});
            return res.data;
        } catch (e) {
            if (isAxiosError(e) && e?.response?.data?.error) {
                setError(e.response.data.error);
            } else {
                setError("Failed to save default broadcast config");
            }
            throw e;
        } finally {
            setSaving(false);
        }
    }, []);

    return {save, saving, error};
}
